import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/admin/diaries/types')({
  component: () => <div>Hello /_app/admin/diaries/types!</div>
})